module.exports = __webpack_public_path__ + "img/banca intesa_color.eceba75b.png";